import React, { Component }  from 'react'
import { connect } from 'react-redux'
import { dispatchActions as dispatchBundleActions } from 'components/bundle/bundleHandlerRedux'
import { dispatchActions as dispatchUserActions } from 'components/user/userHandlerRedux'

import Snackbar from 'react-md/lib/Snackbars';

class BundleContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			toasts: [],
			addToast: this.addToast,
			autohideToast: true,
		};
	}

	addToast = (text, action, autohideToast = true) => {
		const toasts = this.state.toasts.slice();
		toasts.push({ text, action });

		this.setState({ ...this.state, toasts, autohideToast });
	};

	dismissToast = () => {
		const [, ...toasts] = this.state.toasts;
		this.setState({ ...this.state, toasts });
	};

	toggleUserMode = () => this.props.toggleUserMode();

	componentDidMount() {
		const { bundle } = this.props;
		this.props.handleBundleUpdate(bundle);
	}

	render() {
		const { bundle, user } = this.props;
		const { toasts, addToast, autohideToast } = this.state;

		const childProps = {
			bundle,
			user,
			toggleUserMode: this.toggleUserMode,
			toasts,
			addToast
		};

		const renderToasts = () => (
			<Snackbar
				id="bundle-snackbar"
				toasts={toasts}
				autohide={autohideToast}
				onDismiss={this.dismissToast}
			/>
		);

		return (
			<div>
				{ React.Children.map(this.props.children, (child => React.cloneElement(child, childProps))) }
				{ renderToasts() }
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		bundle: state.bundleHandler.bundle,
		user: state.userHandler.user
	}
};

export default connect(mapStateToProps, { ...dispatchBundleActions, ...dispatchUserActions })(BundleContainer);



// WEBPACK FOOTER //
// ./src/components/bundle/containers/BundleContainer.jsx